<template>
  <div class="section-panel end-wrapper" :class="[`mq-${$mq}`]">
    <div class="end-stack">
      <h1>Fetching some news, <span class="swish swish-yellow">just</span> for you.</h1>
      <div class="data-loader">
        <Loading/>
      </div>
      <p>Hey there 👋.  Give me a sec.  I'm scanning the world's news and finding the most important things for you to read.</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // Demo states, to be replaced by engine
        readState: 'skimmed',
        ctaState: 'enable-notifications'
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .data-loader {
    margin: 1rem 0 1.9rem 0;

    .mq-sm & {
      margin: 1.4rem 0 1.9rem 0;
    }
  }

  .section-panel {
    padding: 0 1rem;
    grid-column: span 12;
    grid-row: span 12;
    text-align: center;
  }

  .data-loader {
    margin: 1rem 0 1.9rem 0;
  }

  .end-wrapper {
    margin: auto;

    .end-stack {
      display: flex;
      flex-direction: column;
      max-width: 20rem;

      .data-loader {
        margin: 1rem 0 1.9rem 0;
      }

      p {
        .mq-sm & {
          margin-top: 1rem;
        }
      }

      .swish {
        background-size: 49px;
        background-position: 0px 36px;
        padding-bottom: 10px;

        .mq-sm & {
          background-size: 61px;
          background-position: 0px 42px;
          padding-bottom: 10px;
        }
      }

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1.2rem;

        .read-state {
          display: flex;
          align-items: center;
          justify-content: center;

          &.glanced {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 100%;
            background: rgba($red-tone-3, 0.3);
            padding: 0.1rem;  

            .line-marker {
              height: 2px;
              width: 60%;
              border-radius: 500px;
              background: $red-tone-3;
            }
          }

          &.skimmed {
            justify-content: space-between;
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            background: rgba($orange-tone-3, 0.3);
            padding: 0.3rem;

            .dot-marker {
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: $orange-tone-3;
            }
          }

          &.read {
            justify-content: space-between;
            width: 3.5rem;
            height: 3.5rem;
            border-radius: 50%;
            background: rgba($green-tone-3, 0.3);
            padding: 0.3rem;
            position: relative;
            box-shadow: 0 0 60px 30px rgba($green-tone-3, 0.2);

            .darkmode & {
              box-shadow: 0 0 60px 30px rgba($green-tone-3, 0.1);
            }

            svg {
              position: absolute;
              right: -4px;

              path {
                fill: $green-tone-3;
              }
            }
          }
        }
      }
    }
  }
</style>